import PropTypes from 'prop-types';

export const TaxRateChangePropType = PropTypes.shape({
  companyCode: PropTypes.string.isRequired,
  defGrouping: PropTypes.string.isRequired,
  grossBalance: PropTypes.number.isRequired,
  countryTaxType: PropTypes.string.isRequired,
  bookType: PropTypes.string.isRequired,
  currencyCode: PropTypes.string.isRequired,
  historicalRate: PropTypes.number.isRequired,
  netBalance: PropTypes.number.isRequired,
});
